import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {Accessory} from '../../../interface/accessories';
import {AccessoryService} from '../../../service/accessories.service';
import {catchError, of} from 'rxjs';

export const accessoryDetailResolver: ResolveFn<Accessory | null> = (route) => {
  const accessoryService = inject(AccessoryService);
  const accessoryId = route.paramMap.get('id');

  if (!accessoryId) {
    return of(null);
  }

  return accessoryService.getAccessoryById(+accessoryId).pipe(
    catchError((error) => {
      console.error('Error fetching accessory:', error);
      return of(null);
    })
  );
};
